import * as DialogPrimitive from "@radix-ui/react-dialog";
import { XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const DialogCloseButton = () => {
  const { t } = useTranslation();

  return (
    <DialogPrimitive.Close
      data-slot="dialog-close"
      // `rounded-xs` and `outline-hidden` are Tailwind v4 utilities; on our Tailwind 3 they compile
      // to nothing. Kept verbatim so migrating doesn't change the rendered result.
      className="absolute top-4 right-4 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"
    >
      <XIcon />
      <span className="sr-only">{t("Close")}</span>
    </DialogPrimitive.Close>
  );
};
